import { PDFDocument } from 'pdf-lib';

export interface PdfValidationResult {
  isValid: boolean;
  numPages?: number;
  error?: string;
}

export class PdfValidator {
  static validateDocument(file: Blob): Promise<PdfValidationResult> {
    return file.arrayBuffer()
      .then((buffer) => PDFDocument.load(buffer))
      .then((pdfDoc) => ({
        isValid: true,
        numPages: pdfDoc.getPageCount()
      }))
      .catch(() => ({
        isValid: false,
        error: 'Error processing PDF file!'
      }));
  }
}
